import posthog from 'posthog-js'

export default defineNuxtPlugin({
  name: 'posthog',
  enforce: 'pre',
  setup() {
    const config = useRuntimeConfig()
    const posthogKey = config.public.posthogKey as string

    // Check if we have a real key (not the fallback placeholder) before init
    if (posthogKey && posthogKey !== 'phc_placeholder') {
      const posthogClient = posthog.init(posthogKey, {
        api_host: config.public.posthogHost as string,
        person_profiles: 'identified_only',
        capture_pageview: false, // We handle this manually in the router plugin if needed, or rely on distinct events
        loaded: (posthog) => {
          if (process.env.NODE_ENV === 'development') {
            posthog.debug()
          }
        }
      })

      return {
        provide: {
          posthog: () => posthogClient
        }
      }
    }
  }
})
